import { useState } from "react"
import { usePersonnelDetailsContext } from "../PersonnelDetails"
import { Link } from "react-router-dom"
import {
     CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPES_OPTIONS_FOR_SELECT2,
     CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE,
     CONST_USER_PERMISSIONS_OPTIONS_FOR_SELECT2,
} from "@common-constants/*"
import useUser from "../../../../hooks/useUser"

const InfoProViewOnly = () => {
     const context = usePersonnelDetailsContext()
     const details = context.detailsQuery.data
     const { hasFullStaffManagement } = useUser()

     const p = details?.personnel
     const isNonSalarie = p?.statut === CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE
     const fournisseur = p?.fournisseur
     const fournisseurResponsable = p?.fournisseurResponsable

     // State to handle the "See more" toggle for permissions
     const [showAllPermissions, setShowAllPermissions] = useState(false)

     // Logic for permission display
     const allPermissions: string[] = details?.personnel?.user?.permissions || []
     const hasMore = allPermissions.length > 3
     const displayedPermissions = showAllPermissions ? allPermissions : allPermissions.slice(0, 3)

     return (
          <>
               {/* Statut */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Statut</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.statutLabel}</span>
                    </div>
               </div>

               {/* Contrat */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Contrat</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.contratLabel}</span>
                    </div>
               </div>

               {/* Email - target="_blank" removed to prevent empty Chrome tabs */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Email</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              <a className={"text-dark text-hover-primary"} href={`mailto:${details?.personnel.mailProfessionnel}`} rel={"noreferrer"}>
                                   {details?.personnel.mailProfessionnel}
                              </a>
                         </span>
                    </div>
               </div>

               {/* Téléphone - target="_blank" removed */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Téléphone</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              <a
                                   href={`tel:${details?.personnel.telProfessionnelIndicatif ? details?.personnel.telProfessionnelIndicatif.phoneCodeWithPlusPrefix : ""} ${details
                                        ?.personnel.telProfessionnel}`}
                                   className="text-dark text-hover-primary"
                              >
                                   {details?.personnel.telProfessionnelIndicatif ? details?.personnel.telProfessionnelIndicatif.phoneCodeWithPlusPrefix : ""}{" "}
                                   {details?.personnel.telProfessionnel}
                              </a>
                         </span>
                    </div>
               </div>

               {/* Poste */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Poste</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              {details?.personnel.personnelPostes && details?.personnel.personnelPostes.length > 0 && details?.personnel.personnelPostes[0].poste?.nom}
                         </span>
                    </div>
               </div>

               {/* Agence */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Agence</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.agence?.nom}</span>
                    </div>
               </div>

               {/* Entité de rattachement */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Entité de rattachement</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.mainEntite?.nom}</span>
                    </div>
               </div>

               {/* Entité de facturation */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Entité de facturation</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              {p?.entiteFacturation?.nom ? p?.entiteFacturation?.nom : <span className={"text-warning fw-light"}>Non renseignée</span>}
                         </span>
                    </div>
               </div>

               {/* Date entrée */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Date entrée</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.dateEntree?.format("DD/MM/YYYY")}</span>
                    </div>
               </div>

               {/* Rémunération — salarié : salaire brut + heures ; non salarié : taux journalier HT */}
               {isNonSalarie ? (
                    <div className="row mb-7">
                         <label className="col-lg-4 fw-bold text-muted">Taux journalier HT</label>
                         <div className="col-lg-8">
                              <span className="fw-bolder fs-6 text-dark">
                                   {p?.tauxJournalierHt != null ? `${p?.tauxJournalierHt} €` : <span className={"text-warning fw-light"}>Non renseigné</span>}
                              </span>
                         </div>
                    </div>
               ) : (
                    <>
                         {/* Salaire brut mensuel */}
                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Salaire brut mensuel</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">
                                        {p?.salaireBrutMensuel != null ? `${p?.salaireBrutMensuel} €` : <span className={"text-warning fw-light"}>Non renseigné</span>}
                                   </span>
                              </div>
                         </div>

                         {/* Heures de travail */}
                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Heures de travail</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{details?.personnel.heuresTravail}h / jour</span>
                              </div>
                         </div>

                         {/* Heures supp */}
                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Heures supp.</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{details?.personnel.heuresTravailSupp}h / jour</span>
                              </div>
                         </div>
                    </>
               )}

               {/* Responsable */}
               {details?.responsable && (
                    <div className="row mb-7">
                         <label className="col-lg-4 fw-bold text-muted">Responsable direct</label>
                         <div className="col-lg-8">
                              <Link to={`/gestion/structure/staff/${details?.responsable?.id}/details`} className={"fw-bolder fs-6 text-dark text-hover-primary"}>
                                   {details?.responsable?.prenomNom}
                              </Link>
                         </div>
                    </div>
               )}

               {/* LinkedIn */}
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">LinkedIn</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              {details?.personnel?.linkedinUrl ? details?.personnel?.linkedinUrl : <span className={"text-warning fw-light"}>Non renseigné</span>}
                         </span>
                    </div>
               </div>

               {/* Lignes CRA — concept salarié uniquement */}
               {!isNonSalarie && (
                    <div className="row mb-7">
                         <label className="col-lg-4 fw-bold text-muted">Lignes CRA</label>
                         <div className="col-lg-8">
                              <span className="fw-bolder fs-6 text-dark">
                                   {details?.personnel?.typesLigneActiviteCraAutorises ? (
                                        details?.personnel?.typesLigneActiviteCraAutorises
                                             ?.map(item => CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPES_OPTIONS_FOR_SELECT2.find(item_ => item_.value === item)?.label)
                                             .join(", ")
                                   ) : (
                                        <span className={"text-warning fw-light"}>Non renseigné</span>
                                   )}
                              </span>
                         </div>
                    </div>
               )}

               {/* Fournisseur — collaborateur non salarié uniquement */}
               {isNonSalarie && (
                    <>
                         <h5 className="mt-8 mb-4">Fournisseur</h5>
                         <div className="separator separator-dashed mb-6" />

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Raison sociale</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">
                                        {fournisseur?.raisonSociale ? fournisseur?.raisonSociale : <span className={"text-warning fw-light"}>Non renseignée</span>}
                                   </span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Catégorie</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseur?.typeLabel}</span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Forme juridique</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseur?.formeJuridiqueLabel}</span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">SIRET</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseur?.siret}</span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Adresse</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseur?.adresse}</span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Ville et code postal</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">
                                        {fournisseur?.ville} {fournisseur?.codePostal}
                                   </span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Pays</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseur?.pays?.nomFr}</span>
                              </div>
                         </div>

                         <h5 className="mt-8 mb-4">Contact fournisseur</h5>
                         <div className="separator separator-dashed mb-6" />

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Prénom NOM</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseurResponsable?.prenomNom}</span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Email</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">
                                        {fournisseurResponsable?.email ? (
                                             <a className={"text-dark text-hover-primary"} href={`mailto:${fournisseurResponsable?.email}`}>
                                                  {fournisseurResponsable?.email}
                                             </a>
                                        ) : null}
                                   </span>
                              </div>
                         </div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Téléphone</label>
                              <div className="col-lg-8">
                                   <span className="fw-bolder fs-6 text-dark">{fournisseurResponsable?.tel}</span>
                              </div>
                         </div>
                    </>
               )}

               {/* Permissions — masquées en accès restreint */}
               {hasFullStaffManagement() && (
                    <>
                         <div className="separator separator-dashed my-7"></div>

                         <div className="row mb-7">
                              <label className="col-lg-4 fw-bold text-muted">Permissions</label>
                              <div className="col-lg-8 d-flex flex-column">
                                   {allPermissions.length > 0 ? (
                                        <>
                                             {displayedPermissions.map(permValue => {
                                                  const option = CONST_USER_PERMISSIONS_OPTIONS_FOR_SELECT2.find(opt => opt.value === permValue)
                                                  return (
                                                       <div key={permValue} className="fw-bolder fs-6 text-dark mb-1">
                                                            {option ? option.label : permValue}
                                                       </div>
                                                  )
                                             })}

                                             {hasMore && (
                                                  <div
                                                       className="text-primary fw-bold fs-7 mt-1 cursor-pointer"
                                                       onClick={() => setShowAllPermissions(!showAllPermissions)}
                                                       style={{ cursor: "pointer" }}
                                                  >
                                                       {showAllPermissions
                                                            ? "Voir moins"
                                                            : `Voir plus (${allPermissions.length - 3} autre${allPermissions.length - 3 > 1 ? "s" : ""})`}
                                                  </div>
                                             )}
                                        </>
                                   ) : (
                                        <span className="text-warning fw-light">Aucune permission renseignée</span>
                                   )}
                              </div>
                         </div>
                    </>
               )}
          </>
     )
}

export default InfoProViewOnly
